document.addEventListener('scroll', () => {
    const scrollingSection = document.querySelector('scrolling-image-list');
    if (scrollingSection) {
        // Check if the section is in view
        const rect = scrollingSection.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
            // Apply the style when the section is in view
            scrollingSection.querySelectorAll('.ara-image-right').forEach(image => {
                image.parentElement.parentElement.parentElement.parentElement.style.order = 2;
            });
        }
    }
});



$(document).ready(function(){
  $('.tab_nav li:first-child').addClass('active');
  $('.tabcontent').hide();
  $('.tabcontent:first').show();
  
  // Click function
  $('.tab_nav li').click(function(){
    $('.tab_nav li').removeClass('active');
    $(this).addClass('active');
    $('.tabcontent').hide();
    
    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });  


  $('.product-media-slider').slick({
    slidesToShow:1,
    dots:true,
    arrows:false,
   
  });

  $('.testimonial-inner').slick({
    slidesToShow:2,
    dots:true,
    arrows:false,
     responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,

        }
      }
    ]
  });

  //   $(".slider-range").on( "input", function() {
  //   var divisor = $(this).parents(".before_after_center").find(".divisor")
  //   var handle = $(this).parents(".before_after_center").find(".handle");
  //   var slider = $(this).parents(".before_after_center").find(".slider-range");
  //   handle.css("left",  slider.val()+"%");
  //   divisor.css("width",  slider.val()+"%");
  // });
  
   $('.slick-track').slick({
    slidesToShow:3,
    dots:true,
    arrows:false,
    appendDots: '.result-slick-dots',

     responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

    
   $('.section-result-section-duo .result_slider').slick({
    slidesToShow:3,
    dots:false,
    arrows:true,

     responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
  
$('.faq-question').click(function() {
  $(this).siblings().slideToggle();
  $(this).parents('.faq__item,.faq-item').toggleClass('active');
  $(this).parents('.faq__item,.faq-item').siblings().find('.faq-answer').slideUp();
  $(this).parents('.faq__item,.faq-item').siblings().removeClass('active');
});


  $('.product__accordion summary').click(function() {
  $(this).siblings().slideToggle();
  $(this).parents('.product__accordion').toggleClass('active');
  $(this).parents('.product__accordion').siblings().find('.accordion__content').slideUp();
  $(this).parents('.product__accordion').siblings().removeClass('active');
});


  var $slider = $('.pproduct-list-inner');
  var $progressBar = $('.progress__bar');
  var $progressBarLabel = $('.slider__label');

  // Set initial background size and aria-valuenow
  $progressBar.css('background-size', '2% 100%').attr('aria-valuenow', 2);

  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

    if (calc === 0) {
      $progressBar.css('background-size', '2% 100%').attr('aria-valuenow', 2); // Set background size to 2% if next slide is the first one
    } else {
      $progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
    }

    $progressBarLabel.text(calc + '% completed');
  });

  $slider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    speed: 400,
    
  
    infinite: true, // Enable infinite looping
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 741,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });

  
    $('.scroe_video_slider.default .score_video').slick({
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows:false,
  dots:false,
  centerMode:true,
  responsive: [ 
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1    
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1    
      }
    }     
  ]
});  

$('.template-duo.score_video').slick({
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows:false,
  dots:false,
  centerMode:true,
  responsive: [ 
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1    
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1    
      }
    }     
  ]
}); 

  $(".video-container").each(function() {
  // Video
  var $video_container = $(this);
  var $video = $(this).find("video");

  // Video Controls
  var $video_controls = $(this).find(".video-inner-container");
   var $play_button = $(this).find(".play-gif");

  function playVideo(){
    if ($video[0].paused){
      $video[0].play();
      $video_controls.addClass("playing");
    } else {
      $video[0].pause();
      $video_controls.removeClass("playing"); 
    }
  }

  // Play/pause on button click
  $play_button.click(function() {
    playVideo();
  });

});

var vids = $(".video-container video"); 
$.each(vids, function(){
       this.controls = false; 
});


   function isInViewport(theDiv) {
      let elementTop = theDiv.offset().top;
      let elementBottom = elementTop + theDiv.outerHeight();
      let viewportTop = $(window).scrollTop();
      let viewportBottom = viewportTop + window.innerHeight;
      return elementBottom > viewportTop && elementTop < viewportBottom;
      }
      var animationDone = false;
      if ($('.pro_vid_img_sec').length) {
      $(window).on('scroll', function(){
        if (!animationDone) {
        if(isInViewport($('.pro_vid_img_sec'))) {
          animationDone = true;
         



          $(".circleBarProgress").each(function () {
  var wrapper = $(this).find(".circleBarWrapper");
  var percentEl = $(this).find(".circleBarPercent span");

  var target = parseInt(percentEl.text(), 10);

  var progressColor = wrapper.data("progress-color");
  var bgColor = wrapper.data("progress-bg");

  $({ p: 0 }).animate(
    { p: target },
    {
      duration: 3000,
      easing: "swing",
      step: function (val) {
        wrapper.css({
          background:
            "conic-gradient(" +
            progressColor +
            " 0deg " +
            val +
            "%, " +
            bgColor +
            " " +
            val +
            "%)"
        });

        percentEl.text(Math.floor(val));
      }
    }
  );
});

        }
      }
      });
      }
if ($('#stock-number').length) {
  
  function updateStockNumber() {
    let stockNumber = document.getElementById('stock-number');
    let currentNumber = parseInt(stockNumber.innerText);
    let decreaseAmount = Math.floor(Math.random() * 5) + 1; // Random decrease between 1 and 5
    let newNumber = currentNumber - decreaseAmount;

    if (newNumber > 0) {
        stockNumber.innerText = newNumber;
    } else {
        // Restart the counter from the starting value
        parseInt(stockNumber.getAttribute('data-order'));
    }
}

// Initial update after 2-3 seconds
setTimeout(updateStockNumber, Math.floor(Math.random() * 2001) + 2000); // Random time between 2000ms and 4000ms

// Random updates every 5 seconds
setInterval(() => {
    setTimeout(updateStockNumber, Math.floor(Math.random() * 3001) + 2000); // Random time between 2000ms and 5000ms
}, 5000);
}

}); 

$(document).ready(function () {
  var shippingDays = $('.shipping__date').data('shippingsday');
  function getFormattedDate(date) {
    let monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    let day = days[date.getDay()] + ', ' + date.getDate();
    let month = monthNames[date.getMonth()];

    return `${day} ${month}`;
  }

  function addDaysToDate(date, daysToAdd) {
    let newDate = new Date(date);
    newDate.setDate(date.getDate() + daysToAdd);

    return newDate;
  }

  let todaysDate = new Date();
  let nexttwodaysdate = addDaysToDate(
    todaysDate, shippingDays);
  
  $(".deliverydate").text(" " + getFormattedDate(nexttwodaysdate));
});


  $(document).ready(function(){
        $('a.shipping-modal').click(function(e){
          e.preventDefault();          
          $('.modal.shipping-modal').css('display','block');
          $('body').css('overflow-y','hidden'); //Prevent double scrollbar.
        });

        $('.close-modal,.modal-sandbox').click(function(e){
          e.preventDefault();          
          $('.modal.shipping-modal').css('display','none');
          $('body').css('overflow-y','auto'); //Prevent double scrollbar.
        });
        $('a.value-props-modal').click(function(e){
          e.preventDefault();          
          $('.modal.value-props-modal').css('display','block');
          $('body').css('overflow-y','hidden'); //Prevent double scrollbar.
        });

        $('.close-modal,.modal-sandbox').click(function(e){
          e.preventDefault();          
         $('.modal.value-props-modal').css('display','none');
          $('body').css('overflow-y','auto'); //Prevent double scrollbar.
        });

        $('a.guarantee-value-props-modal').click(function(e){
          $('.modal.guarantee-value-props-modal').css('display','block');
          $('body').css('overflow-y','hidden'); //Prevent double scrollbar.
        });

        $('.close-modal,.modal-sandbox').click(function(e){
          e.preventDefault();          
          $('.modal.guarantee-value-props-modal').css('display','none');
          $('body').css('overflow-y','auto'); //Prevent double scrollbar.
        });
        
        
      });

    $(document).ready(function(){
         var pack2Selector = $('input.block-swatch__radio[value="2 Pack"]'); 
        if (typeof pack2Selector.attr('variant-id') !== 'undefined' && typeof pack2Selector.attr('variant-id') !== false) {
          let pack2VId = pack2Selector.attr('variant-id');
            // pack2Selector.attr("checked","true");
            $('[name="id"]').val(pack2VId); 
             var var_price = pack2Selector.closest('.block-swatch').find('.var_price');
            if (typeof var_price.data('original-price') !== 'undefined' && typeof var_price.data('original-price') !== false) 
              var_price = var_price.data('original-price');
            else 
              var_price = var_price.text();
             var comvar_price = pack2Selector.closest('.block-swatch').find('.var_com_price').text(); 
             var Sdiscount = pack2Selector.closest('.block-swatch').find('.percent-discount').text(); 
              $('.price-list .price.price--highlight').text(var_price);
              $('.price-list .price.price--compare').text(comvar_price);
              $('.product-meta__label-list.label-list .label.label--highlight').text(Sdiscount);
              if ($('#StickyAddToCart .add_to_cart_price').length) {
              $('#StickyAddToCart .add_to_cart_price').text(' - '+var_price);
              $('#StickyAddToCart .product-compare-at-price').text(comvar_price);
              }
              
        }
    });
     

$('.block-swatch__radio').click(function(){
  if ($(this).val() == '2 Pack') {
    $('.swatch-product-free--addon').addClass('add-border');
  }
  else {
    $('.swatch-product-free--addon').removeClass('add-border');
  }
    
});

$(document).on("click",".klaviyo-close-form",function() {
       $('.kl-private-reset-css-Xuajs1').addClass('out');
    });


// Free Gift Product
$(document).ready(function(){

  const freeProductVariantId = $('#freeProductVariantId').attr('freeProductVariantId');
  // const mainProductId = $('#mainProductId').attr('mainProductId');
  const mainProductVariantId = $('.mainProductVariantId');

  if (freeProductVariantId) {

     var found_mainProduct_in_cart = false;
      var found_freeProduct_in_cart = false;
          $.ajax({
          type: 'GET',
          url: '/cart.json',
          dataType: 'json',
          success: function(data) {
            let items = data.items;
            let found_package_in_cart = false;
            let line_item_id = null;
            for(var i=0; i < items.length; i++){
              line_item_id = items[i].id;
              mainProductVariantId.each(function(i, obj) {
              if (line_item_id == $(this).attr('mainProductVariantId'))  
              {
                found_mainProduct_in_cart = true;
              }
              else if ( line_item_id == freeProductVariantId ) {
                found_freeProduct_in_cart = true; 
              }
              });
            }
            if(!found_mainProduct_in_cart && found_freeProduct_in_cart) {
           jQuery.post('/cart/change.json', { quantity: 0, id: freeProductVariantId })
          .done(function() {
            console.log(" Free sachet -  removed ");
            window.location.reload();
           });

         }
            else if(found_mainProduct_in_cart && !found_freeProduct_in_cart) {
          jQuery.post('/cart/add.json', { quantity: 1, id: freeProductVariantId })
          .done(function() {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
             }));
          });
            }
          }
        });

        document.addEventListener('cart:updated', function(event) {
         var cart = event.detail.cart;
            let items = cart.items;
            let found_mainProduct_in_cart = false;
            let found_freeProduct_in_cart = false;
            let line_item_id = null;
            for(var i=0; i < items.length; i++){
              line_item_id = items[i].id;
                mainProductVariantId.each(function(i, obj) {
              if (line_item_id == $(this).attr('mainProductVariantId'))  
              {
                found_mainProduct_in_cart = true;
              }
              else if ( line_item_id == freeProductVariantId ) {
                found_freeProduct_in_cart = true; 
              }
              });

            }
          if (found_mainProduct_in_cart == false && found_freeProduct_in_cart) {
            jQuery.post('/cart/change.json', { quantity: 0, id: freeProductVariantId })
          .done(function() {
            console.log(" Free sachet -  removed");
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
             }));
                           })
          }
          else if (found_mainProduct_in_cart == true && !found_freeProduct_in_cart) {
          jQuery.post('/cart/add.json', { quantity: 1, id: freeProductVariantId })
          .done(function() {
            console.log(" Free sachet -  added ");
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
             }));})
          }
        });
  
  }

  document.addEventListener('variant:changed', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  let varTitle = variant.title;
  console.log(varTitle);
  if (varTitle == '2 Pack') {
    $('.custom-free-product-ids').find('input').attr("disabled", false);
  }
  else {
    $('.custom-free-product-ids').find('input').attr("disabled", true);
  }
});


function isCart() {
  if (document.URL.includes("cart")) return true;
  else false;
}

  $(document).on('click', '.line-item__remove-button.main-product--true', function(e){
       e.preventDefault();
    var updates = {};
    updates[$(this).data('line-id')] = 0;
    updates[freeProductVariantId] = 0;

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => {
      if (isCart()) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
       }));
      setTimeout(function() { 
        location.reload();
    }, 100);
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
             }));
      return response.json();
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    
      });




    $('.block-swatch__radio').change(function() {
   var var_price = $(this).parents('.block-swatch').find('.var_price').text();
   var comvar_price = $(this).parents('.block-swatch').find('.var_com_price').text(); 
    $('#StickyAddToCart .add_to_cart_price').text(var_price);
    $('#StickyAddToCart .product-compare-at-price').text(comvar_price);
  });


  
// marquee-slider
    $('.marquee-poster-slider').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    buttons: false
  });

    
// marquee-slider-section
    $('.marquee-slider-inner').slick({
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 8,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    buttons: false,
    responsive: [ 
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1    
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1    
      }
    }     
  ]
  });

});

     // load star rating badges on the cart page 
      $(document).ready(function(){
          $(document).on('click', '.header__secondary-links a.header__icon-wrapper.tap-area, #AddToCart, .product-item__cta-wrapper button[type="submit"]', () => {
            setTimeout(function () {
              StampedFn.loadBadges();
            }, 2000);
          });
      });



(function () {
  if (window.__UpcartFinalInit) return;
  window.__UpcartFinalInit = true;

  const CART_PATH_PARTS = ['/cart', '/cart/add', '/cart.js', '/cart/update', '/cart/change'];
  const GAP = 12; // must match CSS margin-right for .single_product

  function sleep(ms) { return new Promise(res => setTimeout(res, ms)); }

  function waitForImages(container) {
    const imgs = Array.from(container.querySelectorAll('img'));
    if (!imgs.length) return Promise.resolve();
    return Promise.all(imgs.map(img => new Promise(res => {
      if (img.complete && img.naturalWidth) return res();
      img.addEventListener('load', res, { once: true });
      img.addEventListener('error', res, { once: true });
    })));
  }

  function waitUntilVisible(elem, timeout = 1000, interval = 80) {
    return new Promise(async resolve => {
      const start = Date.now();
      while (Date.now() - start < timeout) {
        const rect = elem.getBoundingClientRect();
        if (rect.width > 4) return resolve(true);
        await sleep(interval);
      }
      resolve(false);
    });
  }

  // Create Swiper instance safely
  function createSwiperSafe(elem, options = {}) {
    if (typeof Swiper === 'undefined') { console.warn('[Upcart] Swiper missing'); return null; }
    try {
      if (!elem.classList.contains('swiper-container')) elem.classList.add('swiper-container');
      return new Swiper(elem, Object.assign({
        slidesPerView: 1,      // FORCE single slide visible
        spaceBetween: GAP,
        loop: true,
        centeredSlides: false,
        allowTouchMove: true,
        watchOverflow: true,
        observer: true,
        observeParents: true
      }, options));
    } catch (e) {
      console.error('[Upcart] Swiper init error', e);
      return null;
    }
  }

  function getPrimarySliderElement() {
    return document.querySelector('.inside-all-products');
  }

  // Choose the slider that's centered in viewport (so arrows control the slider you're looking at)
  function getActiveSwiper() {
    const sliders = Array.from(document.querySelectorAll('.inside-all-products'));
    const viewportCenterY = window.innerHeight / 2;
    for (const s of sliders) {
      const rect = s.getBoundingClientRect();
      if (rect.top <= viewportCenterY && rect.bottom >= viewportCenterY) {
        return (s && s._swiper) ? s._swiper : null;
      }
    }
    // fallback to first initialized swiper
    for (const s of sliders) {
      if (s && s._swiper) return s._swiper;
    }
    return null;
  }

  // attach arrows once, call live swiper instance on click
  function attachArrowsIdempotent() {
    const prev = document.querySelector('.ara-prev');
    const next = document.querySelector('.ara-next');

    if (prev && prev.dataset.araAttached !== 'true') {
      prev.addEventListener('click', (e) => {
        e.preventDefault();
        const sw = getActiveSwiper();
        if (sw) {
          // force move by exactly one slide
          try { sw.slideNext(300); } catch (err) { console.warn(err); }
        }
      });
      prev.dataset.araAttached = 'true';
    }
    if (next && next.dataset.araAttached !== 'true') {
      next.addEventListener('click', (e) => {
        e.preventDefault();
        const sw = getActiveSwiper();
        if (sw) {
          // force move by exactly one slide
          try { sw.slidePrev(300); } catch (err) { console.warn(err); }
        }
      });
      next.dataset.araAttached = 'true';
    }
  }

  // ensure DOM structure matches Swiper requirements:
  // container (sliderElem) -> .swiper-wrapper -> .swiper-slide (our .single_product)
  function ensureSwiperMarkup(sliderElem, cells) {
    let wrapper = sliderElem.querySelector('.swiper-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';
      cells.forEach(c => wrapper.appendChild(c));
      sliderElem.appendChild(wrapper);
    } else {
      const currentSlides = Array.from(wrapper.querySelectorAll('.single_product'));
      if (currentSlides.length !== cells.length) {
        cells.forEach(c => { if (c.parentElement !== wrapper) wrapper.appendChild(c); });
      }
    }
    const wrapperChildren = Array.from(sliderElem.querySelectorAll('.single_product'));
    wrapperChildren.forEach(c => {
      if (!c.classList.contains('swiper-slide')) c.classList.add('swiper-slide');
    });
  }

  // core init for a single slider element
  async function initOneSlider(sliderElem) {
    if (!sliderElem) return;
    if (sliderElem._upcartInitInProgress) return;
    sliderElem._upcartInitInProgress = true;

    const visible = await waitUntilVisible(sliderElem, 1200);
    if (!visible) {
      console.info('[Upcart] slider not visible when initializing — using fallback widths');
    }

    if (sliderElem._swiper) {
      try { sliderElem._swiper.destroy(true, true); } catch (e) {}
      sliderElem._swiper = null;
    }

    sliderElem.classList.add('ara-inline-reset');

    let containerWidth = sliderElem.clientWidth || sliderElem.getBoundingClientRect().width;
    if (!containerWidth || containerWidth < 20) containerWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);

    // FORCE one slide per view (user requested "one slide only one slide for each slide")
    const perView = 1;
    const cellWidth = Math.floor((containerWidth - GAP * (perView - 1)) / perView);

    const cells = Array.from(sliderElem.querySelectorAll('.single_product'));
    if (!cells.length) {
      sliderElem._upcartInitInProgress = false;
      return;
    }

    await waitForImages(sliderElem);

    // set explicit pixel width on each cell (prevents flex quirks)
    cells.forEach(c => {
      c.style.width = cellWidth + 'px';
      c.style.marginRight = GAP + 'px';
    });

    ensureSwiperMarkup(sliderElem, cells);

    const slidesPerView = Math.min(perView, cells.length);

    // create Swiper instance
    const sw = createSwiperSafe(sliderElem, {
      slidesPerView: slidesPerView,
      spaceBetween: GAP,
      loop: cells.length > slidesPerView,
      centeredSlides: false
    });

    if (!sw) {
      sliderElem._upcartInitInProgress = false;
      return;
    }

    sliderElem._swiper = sw;

    try { sw.update && sw.update(); } catch (e) {}
    setTimeout(() => { try { sw.update && sw.update(); } catch (e) {} }, 120);

    attachArrowsIdempotent();

    sliderElem._upcartInitInProgress = false;
  }

  // init all sliders found
  let initPending = null;
  function scheduleInitAll(delay = 100) {
    if (initPending) return;
    initPending = setTimeout(async () => {
      initPending = null;
      const sliders = document.querySelectorAll('.inside-all-products');
      if (!sliders.length) return;
      await Promise.all(Array.from(sliders).map(s => initOneSlider(s)));
    }, delay);
  }

  // network wrappers to trigger re-init after cart changes
  (function wrapNetworkTriggers() {
    if (window.__UpcartFinalFetchWrapped) return;
    window.__UpcartFinalFetchWrapped = true;

    if (window.fetch) {
      const origFetch = window.fetch.bind(window);
      window.fetch = function (...args) {
        return origFetch(...args).then((res) => {
          try {
            const url = (typeof args[0] === 'string') ? args[0] : (args[0] && args[0].url) ? args[0].url : '';
            if (url && CART_PATH_PARTS.some(p => url.indexOf(p) !== -1)) {
              setTimeout(() => scheduleInitAll(140), 220);
            }
          } catch (e) {}
          return res;
        });
      };
    }

    const XProto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (XProto && !window.__UpcartFinalXhrWrapped) {
      window.__UpcartFinalXhrWrapped = true;
      const origOpen = XProto.open;
      const origSend = XProto.send;
      XProto.open = function (method, url) { this.__UpcartURL = url; return origOpen.apply(this, arguments); };
      XProto.send = function () {
        const that = this;
        const onEnd = function () {
          try {
            const url = that.__UpcartURL || '';
            if (url && CART_PATH_PARTS.some(p => url.indexOf(p) !== -1)) setTimeout(() => scheduleInitAll(140), 220);
          } catch (e) {}
          that.removeEventListener('loadend', onEnd);
        };
        this.addEventListener('loadend', onEnd);
        return origSend.apply(this, arguments);
      };
    }
  })();

  ['cart:updated','cart:refresh','drawer:loaded','cart:open','cart:close','cart:render','shopify:section:load','theme:section:load'].forEach(ev => {
    document.addEventListener(ev, () => scheduleInitAll(140));
  });

  document.addEventListener('DOMContentLoaded', () => setTimeout(() => scheduleInitAll(100), 200));
  if (document.readyState === 'complete' || document.readyState === 'interactive') setTimeout(() => scheduleInitAll(100), 200);

  window.Upcart = window.Upcart || {};
  window.Upcart.reinitUpsellSlider = () => scheduleInitAll(0);

  console.info('[Upcart] final slider manager (Swiper) installed — single-slide mode');
})();
